import React from "react";

export const PerformanceStat = (props) =>{
    
    if(props.status == 'up'){
        var boxId = 2
        var icon = 'pi pi-arrow-up'
        var imgsrc="assets/layout/images/dashboard/value.svg"
    }else if(props.status == 'down'){
        var boxId = 1
        var icon = 'pi pi-arrow-down'
        var imgsrc="assets/layout/images/dashboard/rate.svg"
    }else if(props.status == 'balance'){
        var boxId = 3
        var icon = 'pi pi-minus'
        var imgsrc="assets/layout/images/dashboard/quantity.svg"
    }

    return(
        <>
            <div className={`card widget-overview-box widget-overview-box-${boxId}`}>
                <span className="overview-title">
                    {props.title}
                </span>
                <div className="p-d-flex p-jc-between">
                    <div className="overview-detail p-d-flex p-jc-between">
                        {
                            props.value1 ?

                            <div className="overview-badge p-d-flex p-jc-center p-ai-center">
                                <i className={icon}></i>
                                <span>{props.value1}%</span>
                            </div>
                            : 
                            <i className="pi pi-spin pi-spinner p-mt-4"></i>
                        }

                    </div>
                </div>

                <img src={imgsrc ? imgsrc : 'assets/layout/images/dashboard/value.svg' } alt="rate" />
            </div>
        </>
    )
}

